import { render, staticRenderFns } from "./DownloadDocumentDialog.vue?vue&type=template&id=9bf7cdc0"
import script from "./DownloadDocumentDialog.vue?vue&type=script&lang=ts"
export * from "./DownloadDocumentDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports